export default __webpack_public_path__ + "static/media/sp.7742385b.png";